import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";

import { createFileRoute, useLocation, useNavigate } from "@tanstack/react-router";
import { type ReactNode, useState } from "react";
import DetailContent from "@/components/Overview/Accordions/DetailContent";
import Page from "@/components/Page";
import PlannedUnplannedDiagrams from "@/components/Trend/PlannedUnplannedDiagrams";
import TrendContent, { FilterMode } from "@/components/Trend/TrendContent";

type TrendAccordion = {
  name: string;
  title: string;
  content: ReactNode;
  defaultOpen?: boolean;
};

const accordions: TrendAccordion[] = [
  {
    name: "planned_unplanned",
    title: "Fordeling planlagte og ikke-planlagte avbrudd",
    content: <PlannedUnplannedDiagrams />,
  },
  {
    name: "trend",
    title: "Trend (ikke-planlagte avbrudd)",
    content: <TrendContent filterMode={FilterMode.Detailed} />,
    defaultOpen: true,
  },
  {
    name: "details",
    title: "Detaljer (ikke-planlagte avbrudd)",
    content: <DetailContent />,
    defaultOpen: true,
  },
];

function Trend() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeAccordion = location.hash.replace(/^#/, "");
  const [openAccordions, setOpenAccordions] = useState(
    () =>
      new Set(
        accordions.filter((accordion) => accordion.defaultOpen).map((accordion) => accordion.name),
      ),
  );

  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Avbruddsdata
      </Typography>
      {accordions.map((accordion, index) => (
        <Accordion
          aria-controls={`panel${index}a-content`}
          expanded={openAccordions.has(accordion.name) || activeAccordion === accordion.name}
          id={accordion.name}
          key={accordion.name}
          onChange={(_, isExpanded) => {
            setOpenAccordions((previous) => {
              const next = new Set(previous);
              if (isExpanded) {
                next.add(accordion.name);
              } else {
                next.delete(accordion.name);
              }
              return next;
            });

            if (isExpanded || activeAccordion === accordion.name) {
              void navigate({
                hash: isExpanded ? accordion.name : "",
                replace: true,
              });
            }
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">{accordion.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>{accordion.content}</AccordionDetails>
        </Accordion>
      ))}
    </Page>
  );
}

export const Route = createFileRoute("/_auth/trend")({
  component: Trend,
});
